export default "__VITE_PUBLIC_ASSET__857c7164__"